import { getValue, getFullUrl, getSelectionValue } from 'utils/utilityHelper'
import Video from './Video'

const VideoAcousticData = (props) => {
  const { 
    caption,
    image,
    src,
    subtitle,
    title,
    titleTag,
    transcript 
  } = props.data
  
  return  (
    <Video
      caption={getValue(caption)}
      image={image?.url ? getFullUrl(image?.url) : null}
      src={src?.url ? getFullUrl(src?.url) : null}
      subtitle={subtitle?.url ? getFullUrl(subtitle?.url) : null}
      title={getValue(title)}
      titleTag={getSelectionValue(titleTag)}
      transcript={transcript?.url ? getFullUrl(transcript?.url) : null}
    />
  )
}

export default VideoAcousticData